import React from 'react';
import PropTypes from 'prop-types';
import styles from './SmallText.module.scss';
const SmallText = ({ text, classes }) => {
    let clazzes = [styles.smallText];
    if (classes) {
        if (typeof classes === 'string') {
            clazzes.push(classes);
        }
        else {
            clazzes = clazzes.concat(classes);
        }
    }
    return React.createElement("small", { className: clazzes.join(' ') }, text);
};
SmallText.propTypes = {
    classes: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
    text: PropTypes.string.isRequired,
};
SmallText.defaultProps = {
    classes: [],
};
export default SmallText;
//# sourceMappingURL=SmallText.js.map